import { Field, Panel } from "./Fields";

const GROUPS = [
  {
    title: "Textos da tela inicial",
    fields: [
      ["hero_badge", "Texto acima do título"],
      ["hero_title", "Título principal"],
      ["hero_subtitle", "Subtítulo", true],
      ["btn_accommodations", "Botão — acomodações"],
      ["btn_whatsapp", "Botão — WhatsApp"],
      ["btn_call", "Botão — ligar"],
      ["btn_directions", "Botão — como chegar"],
    ],
  },
  {
    title: "Contatos e endereço",
    desc: "Estes dados alimentam todos os botões de WhatsApp, ligação e o mapa.",
    fields: [
      ["whatsapp_number", "WhatsApp (somente números, com 55 + DDD)", false, "Ex.: 5511975513718 — usado nos links wa.me"],
      ["whatsapp_display", "WhatsApp (como aparece no site)"],
      ["phone_display", "Telefone fixo (como aparece no site)"],
      ["phone_number", "Telefone para ligação (com +55)", false, "Ex.: +551131059340"],
      ["email", "E-mail (opcional)"],
      ["address_line", "Endereço"],
      ["address_city", "Cidade / estado"],
      ["address_cep", "CEP"],
      ["maps_query", "Endereço usado no mapa e no 'Como chegar'"],
    ],
  },
  {
    title: "Mensagens automáticas do WhatsApp",
    desc: "Texto já preenchido quando o visitante clica em cada botão.",
    fields: [
      ["wa_msg_default", "Botão flutuante e tela inicial", true],
      ["wa_msg_accommodations", "Acomodações (geral)", true],
      ["wa_msg_reservations", "Reservas (localização e contato)", true],
      ["wa_msg_room", "Card de acomodação", true, "Use {acomodacao} para inserir o nome da categoria."],
    ],
  },
  {
    title: "Títulos das seções",
    fields: [
      ["acc_label", "Acomodações — rótulo"], ["acc_title", "Acomodações — título"], ["acc_subtitle", "Acomodações — subtítulo", true],
      ["gallery_label", "Galeria — rótulo"], ["gallery_title", "Galeria — título"], ["gallery_subtitle", "Galeria — subtítulo", true],
      ["features_label", "Diferenciais — rótulo"], ["features_title", "Diferenciais — título"], ["features_subtitle", "Diferenciais — subtítulo", true],
      ["location_label", "Localização — rótulo"], ["location_title", "Localização — título"], ["location_text", "Localização — texto", true],
      ["contact_label", "Contato — rótulo"], ["contact_title", "Contato — título"], ["contact_text", "Contato — texto", true],
      ["footer_text", "Rodapé — texto", true],
    ],
  },
  {
    title: "SEO e privacidade",
    fields: [
      ["hotel_name", "Nome do hotel"],
      ["seo_title", "Título da página (Google / aba do navegador)"],
      ["seo_description", "Descrição para o Google", true],
      ["privacy_text", "Política de privacidade", true],
    ],
  },
];

export const SettingsTab = ({ settings, onChange }) => (
  <div className="space-y-6">
    {GROUPS.map((g) => (
      <Panel key={g.title} title={g.title} desc={g.desc}>
        <div className="grid md:grid-cols-2 gap-5">
          {g.fields.map(([key, label, multiline, help]) => (
            <div key={key} className={multiline ? "md:col-span-2" : ""}>
              <Field label={label} value={settings[key]} multiline={multiline} help={help} onChange={(v) => onChange(key, v)} testid={`setting-${key}`} />
            </div>
          ))}
        </div>
      </Panel>
    ))}
  </div>
);
